<template>
    <base-layout v-if="space_permission('SPACE_UPDATE') && detail.data.id" :theme="detail.data.theme">
        <template slot="sidebar">
            <space-sidebar :space="detail.data" class="sidebar-content hide-scroll-bar"/>
        </template>

        <div class="column scroll has-background-light content-section">
            <div class="is-clearfix">
                <h1 class="title is-pulled-left">Space Settings</h1>
                <user-avatar class="is-pulled-right"/>
            </div><br/>

            <base-backend-errors :data="update.error"/>

            <base-message v-if="update.succeed" type="is-success">
                <strong>Updated</strong>
            </base-message>

            <div class="columns">
                <div class="column">
                    <div class="box">
                        <h4 class="title is-6">General</h4>
                        <space-settings-general :space="detail.data"/>
                    </div>

                    <div class="box">
                        <div class="columns">
                            <div class="column">
                                <strong>Avatar</strong><br/><br/>
                                <space-settings-avatar :space="detail.data"/>
                            </div>

                            <div class="column">
                                <b>Theme</b>
                                <space-settings-theme :space="detail.data"/>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="column">
                    <div class="box is-fullheight">
                        <h4 class="title is-6">Advanced</h4>
                        <space-settings-access :space="detail.data"/> <hr/>
                        <space-settings-storage :space="detail.data"/> <hr/>
                        <space-settings-export :space="detail.data"/> <hr/>
                        <space-settings-delete :space="detail.data"/>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="box">
                        <space-teams :space="detail.data"/><br/><br/>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <div class="box">
                        <space-members :space="detail.data"/><br/>
                    </div>
                </div>
            </div>
        </div>
    </base-layout>

    <h1 v-else-if="!space_permission('SPACE_UPDATE')" class="title is-4">You have not access</h1>

    <h1 v-else class="loader-container has-text-centered">
        <span class="loader is-inline-flex"></span>
    </h1>
</template>

<script>
import { mapState } from 'vuex';
import BaseLayout from '../components/layouts/BaseLayout.vue';
import SpaceSidebar from '../components/space/SpaceSidebar.vue';
import SpaceSettingsGeneral from '../components/space/SpaceSettingsGeneral.vue';
import SpaceTeams from '../components/space/SpaceTeams.vue';
import SpaceMembers from '../components/space/SpaceMembers.vue';
import UserAvatar from '../components/user/UserAvatar.vue';
import SpaceSettingsStorage from '../components/space/SpaceSettingsStorage.vue';
import SpaceSettingsTheme from '../components/space/SpaceSettingsTheme.vue';
import SpaceSettingsDelete from '../components/space/SpaceSettingsDelete.vue';
import SpaceSettingsAccess from '../components/space/SpaceSettingsAccess.vue';
import SpaceSettingsExport from '../components/space/SpaceSettingsExport.vue';
import SpaceSettingsAvatar from '../components/space/SpaceSettingsAvatar.vue';
import { set_title } from '../utils/helpers';

export default {
    name: 'SpacesSettings',
    components: {
        SpaceSettingsAvatar,
        SpaceSettingsExport,
        SpaceSettingsAccess,
        SpaceSettingsDelete,
        SpaceSettingsTheme,
        SpaceSettingsStorage,
        UserAvatar,
        SpaceSettingsGeneral,
        SpaceSidebar,
        BaseLayout,
        SpaceMembers,
        SpaceTeams,
    },
    computed: mapState('spaces', ['detail', 'update']),
    async created() {
        await this.$store.dispatch('spaces/detail', { space_id: this.$route.params.space });
        set_title(this.detail.data.name);
    },
    destroyed() {
        this.$store.commit('spaces/space_update_clear');
    },
};
</script>
